import React from 'react';

import { Button, buttonClasses, ButtonProps, styled } from '@mui/material';

import { ArrowRight2, ChevronRight } from '../../../assets/icons';

type Props = ButtonProps & {
  label: string;
};

const SubmitButton: React.FC<Props> = ({ children, label, ...rest }) => (
  <StyledSubmitButton variant="outlined" {...rest}>
    <ArrowRight2 className="mobile-icon" />
    <span>{label}</span>
    <ChevronRight />
  </StyledSubmitButton>
);

export default SubmitButton;

const StyledSubmitButton = styled(Button)(({ theme }) => ({
  ...theme.typography.h6,
  width: '100%',
  color: 'var(--color-light-red)',

  '.mobile-icon': {
    display: 'none',
  },

  [theme.breakpoints.only('xs')]: {
    svg: {
      display: 'none',

      '&.mobile-icon': {
        display: 'block',
        width: '36px',
        height: '36px',
      },
    },

    gap: '8px',
    paddingTop: '0 !important',
    paddingBottom: '0 !important',
  },

  'svg:not(.mobile-icon)': {
    width: '42px',
    height: '42px',
  },

  [theme.breakpoints.up('sm')]: {
    minHeight: '80px',
    gridRow: '1 / 3',
    gridColumn: '2 / 3',

    span: { display: 'none' },
  },

  [`&.${buttonClasses.outlined}`]: {
    paddingLeft: 0,
    paddingRight: 0,
  },
}));
